var React = require('react');

function Envelope (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("polygon",{"points":"16,12.8 1.5,0 30.5,0 \t","key":0}),React.createElement("polygon",{"points":"10.2,10 0,18.9 0,1.1 \t","key":1}),React.createElement("polygon",{"points":"11.5,11.2 16,15.1 20.5,11.2 30.5,20 1.5,20 \t","key":2}),React.createElement("polygon",{"points":"21.8,10 32,1.1 32,18.9 \t","key":3})]));
}

Envelope.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","width":"32px","height":"20px","viewBox":"0 0 32 20","style":{"enableBackground":"new 0 0 32 20"},"xmlSpace":"preserve"};

module.exports = Envelope;

Envelope.default = Envelope;
